export default angular
  .module('doxy.global.models.institution', [])
  .service('InstitutionMethods', function () {
    return {
      _ehrUrlCache: {},

      getEhrUrl(person) {
        if (!this.emrUrl) return;
        if (!person || !person.state || !person.state.pid) return;
        if (this._ehrUrlCache[person.state.pid])
          return this._ehrUrlCache[person.state.pid];
        return (this._ehrUrlCache[person.state.pid] = this.emrUrl.replace(
          ':pid',
          encodeURIComponent(person.state.pid)
        ));
      },

      isNull() {
        return !this.id;
      },

      canStyle() {
        if (this.isNull()) return false;
        return [
          'frontColor',
          'backgroundColor',
          'logoHorizontal',
          'logoVertical',
        ].every((key) => {
          return !!this[key];
        });
      },
    };
  }).name;
